"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var Box_1 = __importDefault(require("./Box"));
var Input_1 = __importDefault(require("./Input"));
var Label_1 = __importDefault(require("./Form/Label"));
var Container = (0, styled_1.default)(Box_1.default)({
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
});
var RadioInput = (0, styled_1.default)(Input_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        width: '18px',
        height: '18px',
        accentColor: theme.colors.primary,
        // for tab highlight
        ':focus': {
            boxShadow: theme.boxShadows.main
        },
        ':hover': {
            boxShadow: theme.boxShadows.main
        },
    });
});
function Radio(props, ref) {
    var id = props.id, label = props.label, labelClickable = props.labelClickable, rest = __rest(props, ["id", "label", "labelClickable"]);
    var idRef = (0, react_1.useRef)();
    if (labelClickable && !idRef.current) {
        idRef.current = id || label;
    }
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(RadioInput, __assign({ id: idRef.current, ref: ref }, rest, { type: "radio" })),
        react_1.default.createElement(Label_1.default, { htmlFor: idRef.current }, label)));
}
exports.default = react_1.default.forwardRef(Radio);
